import { DefaultService } from "@/api/SolarCloudApi";
import { QueryConfig } from "@/lib/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export default function getUsersOrdersQueryOptions() {
  return queryOptions({
    queryKey: ["usersOrders"],
    queryFn: getUsersOrders,
    retry: false,
    staleTime: 1000 * 60 * 60, // 1 hour
  });
}

async function getUsersOrders() {
  // const response = await DefaultService.existingOrderSearch();
  // const response = await DefaultService.orderSearch();
  const response = await DefaultService.myOrderSearch();
  return response?.collection ?? [];
}

type useUsersOrdersOptions = {
  queryConfig?: QueryConfig<typeof getUsersOrdersQueryOptions>;
};

export function useUsersOrders({ queryConfig }: useUsersOrdersOptions = {}) {
  return useQuery({
    ...getUsersOrdersQueryOptions(),
    ...queryConfig,
  });
}
